export default __webpack_public_path__ + "static/media/a020-market-3.b635a130.svg";